import { Expose } from 'class-transformer';

export class ShippingProcessConfigResponseDto {
    /**
     * Shipping process configuration ID
     * @example '123e4567-e89b-12d3-a456-426614174000'
     */
    @Expose()
    id: string;

    /**
     * Client Information Record ID
     * @example '123e4567-e89b-12d3-a456-426614174000'
     */
    @Expose()
    clientInformationRecordId: string;

    /**
     * Warehouse Detail ID reference
     * @example '123e4567-e89b-12d3-a456-426614174000'
     */
    @Expose()
    warehouseDetailId?: string;

    /**
     * Product ID reference
     * @example '123e4567-e89b-12d3-a456-426614174000'
     */
    @Expose()
    productId?: string;

    /**
     * Shipping direction (Inbound or Outbound)
     * @example 'Inbound'
     */
    @Expose()
    direction?: string;

    /**
     * Is controlled temperature shipping used?
     * @example true
     */
    @Expose()
    controlledTempShippingUsed?: boolean;

    /**
     * Type of container/vehicle
     * @example 'Topa Thermal, CSafe RKN, Credo Cubes'
     */
    @Expose()
    containerOrVehicleType?: string;

    /**
     * Are temperature data loggers used?
     * @example true
     */
    @Expose()
    tempDataLoggersUsed?: boolean;

    /**
     * Type of logger
     * @example 'LIBERO CB, Sensitech'
     */
    @Expose()
    loggerType?: string;

    /**
     * Logger location (Internal, External for inbound)
     * @example 'Internal'
     */
    @Expose()
    loggerLocation?: string;

    /**
     * Is heated service required?
     * @example false
     */
    @Expose()
    heatedServiceRequired?: boolean;

    /**
     * Date range for heated service
     * @example 'November-March'
     */
    @Expose()
    heatedServiceDateRange?: string;

    /**
     * Protect from freezing required (for Outbound)
     * @example true
     */
    @Expose()
    protectFromFreezingRequired?: boolean;

    /**
     * Transportation provider name
     * @example 'DHL Global Forwarding, FedEx Custom Critical, ATS'
     */
    @Expose()
    transportationProviderName?: string;

    /**
     * Client logistics contact ID
     * @example '123e4567-e89b-12d3-a456-426614174000'
     */
    @Expose()
    logisticsContactId?: string;

    /**
     * Notes
     * @example 'Alternate providers, US-labelled product details'
     */
    @Expose()
    notes?: string;

    /**
     * Creation timestamp
     * @example '2024-01-15T10:30:00Z'
     */
    @Expose()
    createdAt: Date;

    /**
     * Last update timestamp
     * @example '2024-01-15T14:45:00Z'
     */
    @Expose()
    updatedAt: Date;
}
